module.exports = __webpack_public_path__ + "static/img/1a (6).828ba42f.png";